function ContactPage() {
  return (
    <section className="section contact">
      <div className="contact-card reveal" style={{ '--delay': '0ms' }}>
        <h1>Get in touch</h1>
        <p className="lede">Choose the brand that matches your question.</p>
        <div className="contact-grid">
          <div className="detail-card reveal" style={{ '--delay': '120ms' }}>
            <div className="business-brand">
              <img
                className="business-logo leanfactor-logo"
                src={`${process.env.PUBLIC_URL}/LeanFactorLogo.png`}
                alt="Lean Factor logo"
              />
              <h2 className="app-title leanfactor-title">Lean Factor</h2>
            </div>
            <p className="contact-copy">
              For project management support, delivery coordination, and anything related to project management.
            </p>
            <a className="btn ghost" href="mailto:sylviedebrabanter@leanfactor.eu">
              sylviedebrabanter@leanfactor.eu
            </a>
          </div>
          <div className="detail-card reveal" style={{ '--delay': '220ms' }}>
            <div className="business-brand">
              <img
                className="business-logo"
                src={`${process.env.PUBLIC_URL}/JellyBeanStudiosLogo.png`}
                alt="JellyBeanStudios logo"
              />
              <h2 className="app-title">JellyBeanStudios</h2>
            </div>
            <p className="contact-copy">
              For app development, product ideas, and anything related to the studio's apps.
            </p>
            <a className="btn ghost" href="mailto:sylvie.debrabanter@jellybeanstudios.be">
              sylvie.debrabanter@jellybeanstudios.be
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ContactPage;
